<!-- 系统维护/更新中：与登录页同布局，左侧不变，右侧仅提示文字 -->
<template>
  <div class="vben-login-page zone-login">
    <div class="vben-login-left">
      <div class="vben-brand">
        <BrandLogoMark
          v-if="branding.useLogoImage"
          :logo-url="branding.logoUrl"
          :logo-caption="branding.logoCaption"
          :logo-alt="branding.logoAlt"
          variant="md"
          on-dark
        />
        <div class="vben-brand-text">
          <span class="vben-brand-name">{{ branding.productName }}</span>
          <span class="vben-brand-slogan">{{ branding.slogan }}</span>
        </div>
      </div>
      <div class="vben-slogan-wrap">
        <div class="vben-slogan-image">
          <img
            v-if="sloganImageUrl"
            :src="sloganImageUrl"
            alt="产品示意"
            class="vben-slogan-img"
          />
          <div v-else class="vben-slogan-placeholder">
            <span>数据驾驶舱</span>
          </div>
        </div>
        <p class="vben-page-title">懂你的股东智能决策系统</p>
        <p class="vben-page-desc">股权穿透 · 筹码成本 · 交易趋势 · 唯一性分析，为决策提供数据支撑</p>
      </div>
    </div>

    <div class="vben-login-right">
      <div class="vben-maintenance-wrap">
        <div class="vben-maintenance-icon">🔧</div>
        <h1 class="vben-maintenance-title">系统更新中</h1>
        <p class="vben-maintenance-desc">请稍后再试</p>
      </div>
      <footer class="vben-footer">
        Copyright © {{ new Date().getFullYear() }} {{ branding.copyrightName }}
      </footer>
    </div>
  </div>
</template>

<script setup>
import '@/styles/zone-login.css'
import '@/styles/brand-logo-mark.css'
import { resolveBrandingFromWindow } from '@/config/tenantBranding.js'
import BrandLogoMark from '@/components/BrandLogoMark.vue'

const branding = resolveBrandingFromWindow()
const sloganImageUrl = '/images/login-slogan.svg'
</script>

<style scoped>
.vben-maintenance-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  padding: 24px;
  text-align: center;
}
.vben-maintenance-icon {
  font-size: 64px;
  margin-bottom: 24px;
  opacity: 0.9;
}
.vben-maintenance-title {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 12px 0;
}
.vben-maintenance-desc {
  font-size: 18px;
  color: #64748b;
  margin: 0;
}
</style>
